const httpCodes: Record<number, string> = {
  401: 'Unauthorized.',
  404: 'Not Found.',
  413: 'Upload Too Large.',
  429: 'Too Many Requests.',
  500: 'Internal Server Error.',
};

export default httpCodes;
